import "./SeparatedSection.scss";

export default {
  root: "im-separated-section",
  separator: "im-separated-section__separator",
};
